import { psiBadge } from '../../shared/utils/stat-helpers';

export function PsiBadge({ psi }: { psi: number }) {
  const b = psiBadge(psi);
  return <span className={`badge ${b.cls}`}>{b.label}</span>;
}
